import { 
  Box, 
  List, 
  ListItem, 
  ListItemText, 
  Divider, 
  ListSubheader, 
  ListItemButton 
} from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

const SettingsList = ({setShowList, setSettingSelected, setSettingLabel, storeList}) => {

  const history = useHistory();

  function storesStatus(setting) {
    const numberOfStores = storeList.filter(store => store[setting] === '1').length;
    if(numberOfStores === storeList.length) {
      return 'Active at all stores'
    } else if(numberOfStores === 0) {
      return 'Inactive at all stores'
    }
    return 'Active at select stores'
  }

  const goToHome = () => {
    history.push('/home');
  };

  return(
    <Box sx={{marginTop: '30px'}}>
      <div className='title-container'>
        Settings
      </div>
      <Box className='settings-box' sx={{ border: '1px solid', borderColor: 'grey.300', borderRadius: 1 }}>

        <nav aria-label="main setting folders">
          <List>
            <ListItem sx={{cursor: 'pointer'}} onClick={goToHome}>
              <ArrowBackIos fontSize="small" />
              <span className='settings-home'>Home</span>
            </ListItem>
          </List>
        </nav>

        <Divider />

        <nav aria-label="secondary setting folders">
          <List subheader={<ListSubheader color='primary' sx={{fontSize: '20px', fontWeight: 400}}>Integrations</ListSubheader>}>
            <ListItem sx={{paddingLeft:'30px', paddingRight: '40px'}} disablePadding>
              <ListItemButton onClick={() => {setShowList(false); setSettingSelected('appt_calendar'); setSettingLabel('Next Appointment')}}>
                <ListItemText primary="Next Appointment" secondary={storesStatus('appt_calendar')} />
                <ArrowForwardIos fontSize="small" />
              </ListItemButton>
            </ListItem>
            <Tooltip title="This feature can't be enabled until we have the number of bays for each store in ODS">
              <span>
                <ListItem sx={{ paddingLeft: '30px', paddingRight: '40px' }} disablePadding>
                  <ListItemButton disabled={true} onClick={() => { setShowList(false); setSettingSelected('smart_promise_time'); setSettingLabel('Suggested Promise Time') }}>
                    <ListItemText primary="Suggested Promise Time" secondary={storesStatus('smart_promise_time')}
                      sx={{
                        '.MuiListItemText-primary': {
                          color: 'text.disabled' // This will make the text gray
                        },
                        '.MuiListItemText-secondary': {
                          color: 'text.disabled'
                        }
                      }} />
                    <ArrowForwardIos fontSize="small" />
                  </ListItemButton>
                </ListItem>
              </span>
            </Tooltip>
            <ListItem sx={{paddingLeft:'30px', paddingRight: '40px'}} disablePadding>
              <ListItemButton onClick={() => {setShowList(false); setSettingSelected('courtesy_lyft'); setSettingLabel('Courtesy Rides')}}>
                <ListItemText primary="Courtesy Rides" secondary={storesStatus('courtesy_lyft')} />
                <ArrowForwardIos fontSize="small" />
              </ListItemButton>
            </ListItem>
          </List>
        </nav>

        <Divider sx={{width: '90%', margin: 'auto'}}/>

        <nav aria-label="tertiary setting folders">
          <List subheader={<ListSubheader color='primary' sx={{fontSize: '20px', fontWeight: 400}}>SMS Automation</ListSubheader>}>
            <ListItem sx={{paddingLeft:'30px', paddingRight: '40px'}} disablePadding>
              <ListItemButton onClick={() => {setShowList(false); setSettingSelected('readySms'); setSettingLabel('Vehicle Ready - WO Completed')}}>
                <ListItemText primary="Vehicle Ready - WO Completed" secondary={storesStatus('readySms')} />
                <ArrowForwardIos fontSize="small" />
              </ListItemButton>
            </ListItem>
            <ListItem sx={{paddingLeft:'30px', paddingRight: '40px'}} disablePadding>
              <ListItemButton onClick={() => {setShowList(false); setSettingSelected('promisedSms'); setSettingLabel('Promise Time')}}>
                <ListItemText primary="Promise Time" secondary={storesStatus('promisedSms')}/>
                <ArrowForwardIos fontSize="small" />
              </ListItemButton>
            </ListItem>
            <ListItem sx={{paddingLeft:'30px', paddingRight: '40px'}} disablePadding>
              <ListItemButton onClick={() => {setShowList(false); setSettingSelected('multiple_sms'); setSettingLabel('Multiple Call Store SMS')}}>
                <ListItemText primary="Multiple Call Store SMS" secondary={storesStatus('multiple_sms')}/>
                <ArrowForwardIos fontSize="small" />
              </ListItemButton>
            </ListItem>
            <ListItem sx={{paddingLeft:'30px', paddingRight: '40px'}} disablePadding>
              <ListItemButton onClick={() => {setShowList(false); setSettingSelected('global_beback'); setSettingLabel('Global Beback SMS')}}>
                <ListItemText primary="Global Beback SMS" secondary={storesStatus('global_beback')}/>
                <ArrowForwardIos fontSize="small" />
              </ListItemButton>
            </ListItem>
            <ListItem sx={{paddingLeft:'30px', paddingRight: '40px'}} disablePadding>
              <ListItemButton onClick={() => {setShowList(false); setSettingSelected('promise_time_appointments'); setSettingLabel('Promise Time - Appointments')}}>
                <ListItemText primary="Promise Time - Appointments" secondary={storesStatus('promise_time_appointments')}/>
                <ArrowForwardIos fontSize="small" />
              </ListItemButton>
            </ListItem>
          </List>
        </nav>

      </Box>
    </Box>
  )
}

SettingsList.propTypes = {
  setShowList: PropTypes.func,
  setSettingSelected: PropTypes.func,
  setSettingLabel: PropTypes.func,
  storeList: PropTypes.array
};

export default SettingsList;
